/* ============================================
   CENTRAL CONTENT STORE
   All approved public copy (from the content blueprint PDF)
   and all image mappings live here. Phase 2 photographs only
   need a path added to IMAGE_SLOTS below — no page changes.
   ============================================ */

export const CONTACT = {
    email: "dasamahavidya.chetla@gmail.com",
    phoneDisplay: "+91 75950 93299",
    phoneHref: "tel:+917595093299",
    whatsappHref: "https://wa.me/917595093299",
    address: "78B, Peary Mohan Roy Road, Kolkata – 700027",
    locality: "Chetla, Kolkata, West Bengal, India",
};

export const IMAGES = {
    hero: "/assets/hero-altar.jpg",
    logoMain: "/assets/logo-main.png",
    logoTransparent: "/assets/logo-transparent.png",
};

/* Phase 2 image slots — `src` points at the authentic photograph;
   slots with `src: null` render a labelled placeholder until the
   photograph is supplied. Alt text describes the actual image.
   variant: "portrait" (full idol — never cropped, width-constrained),
            "wide" (landscape scenes, natural ratio),
            "doc" (documentary — proportionate 4/3 crop, `focus` sets the
            object-position so the important subject stays in frame). */
export const IMAGE_SLOTS = {
    vidyaKali: {
        label: "Maa Shabashivam Kali",
        src: "/assets/photos/CDP_Maa_Shabashivam_Kali.jpg",
        alt: "Maa Shabashivam Kali — the first Mahavidya of the Chetla celebration, standing in her fierce form upon the reclining figures, with her nameplate 'শবশিবম' below",
        variant: "portrait",
    },
    vidyaTara: {
        label: "Maa Tara",
        src: "/assets/photos/CDP_MAA_TARA.jpg",
        alt: "Maa Tara — the blue Goddess standing upon the reclining Shiva, wearing a tiger skin and a garland of heads, her nameplate 'তারা' below",
        variant: "portrait",
    },
    vidyaShoroshi: {
        label: "Maa Shoroshi",
        src: "/assets/photos/CDP_Maa_Shoroshi.jpg",
        alt: "Maa Shoroshi (Shodashi) enthroned in red and silver, with the assembled deities at her feet and her nameplate 'ষোড়শী' below",
        variant: "portrait",
    },
    vidyaBhuvaneshwari: {
        label: "Maa Bhuvaneshwari",
        src: "/assets/photos/CDP_Maa_Bhuvaneshwari.jpg",
        alt: "Maa Bhuvaneshwari enthroned in orange and green, four-armed, with her nameplate 'ভুবনেশ্বরী' below",
        variant: "portrait",
    },
    vidyaBhairavi: {
        label: "Maa Bhairavi",
        src: "/assets/photos/CDP_MAA_BHAIROBI.jpg",
        alt: "Maa Bhairavi seated in orange robes with rudraksha beads and a garland of skulls, her nameplate 'ভৈরবী' below",
        variant: "portrait",
    },
    vidyaChhinamasta: {
        label: "Maa Chhinamasta",
        src: "/assets/photos/CDP_MAA_CHINAAMASTHA.jpg",
        alt: "Maa Chhinnamasta — the crimson Goddess holding her own head and the scimitar, flanked by her two attendants, with her nameplate 'ছিন্নমস্তা' below",
        variant: "portrait",
    },
    vidyaDhumavati: {
        label: "Maa Dhumavati",
        src: "/assets/photos/CDP_DHUMAVATI_MAA.jpg",
        alt: "Maa Dhumavati — the pale Goddess in white widow's robes holding the winnowing fan, crows perched on her black-and-silver arch, with her nameplate 'ধূমাবতী' below",
        variant: "portrait",
    },
    vidyaBogola: {
        label: "Maa Bogola",
        src: "/assets/photos/CDP_BOGOLA.jpg",
        alt: "Maa Bagalamukhi (Maa Bogola) at the Chetla Dasamahavidya Puja — the golden-robed Goddess seated, holding the tongue of the restrained opponent, with her nameplate below",
        variant: "portrait",
    },
    vidyaMatangi: {
        label: "Maa Matangi",
        src: "/assets/photos/CDP_MAA_MATANGI.jpg",
        alt: "Maa Matangi in green, playing the veena, with her nameplate 'মাতঙ্গী' below",
        variant: "portrait",
    },
    vidyaKomola: {
        label: "Maa Komola",
        src: "/assets/photos/CDP_MAA_KAMALA.jpg",
        alt: "Maa Kamala (Maa Komola) in pink and gold, flanked by two white elephants, with her nameplate 'কমলা' below",
        variant: "portrait",
    },
    adiMaa: {
        label: "Adi Maa",
        src: "/assets/photos/CDP_ADI_MAA_2.jpg",
        alt: "Adi Maa at the Chetla Dasamahavidya Puja — the central idol adorned in red hibiscus garlands with a golden crown and ochre silk, offerings at her feet",
        variant: "portrait",
    },
    shyamaMaa: {
        label: "Shyama Maa",
        src: "/assets/photos/CDP_MAA-SHYAMA.jpg",
        alt: "Shyama Maa — the blue four-armed Goddess with sword and blessing hand, standing upon the reclining Shiva, her nameplate 'শ্যামাকালী' below",
        variant: "portrait",
    },
    kumariPuja: {
        label: "Kumari Puja",
        src: "/assets/photos/CDP_KUMARI_PUJA.jpg",
        alt: "Kumari Puja during the night-long Dasamahavidya observance — the young Kumari seated on the golden throne as the priest offers worship, with the Mahavidyas behind",
        variant: "wide",
    },
    cultural: {
        label: "Cultural programme",
        src: "/assets/photos/CDP_CULTURAL_PROG_FINAL.jpg",
        alt: "A classical dancer performing on the Dasamahavidya Puja stage in Chetla, with the celebration banner behind",
        variant: "doc",
        focus: "center 30%",
    },
    children: {
        label: "Children's competitions",
        src: "/assets/photos/CDP_CHILDRENS_COMPETITIONS.jpg",
        alt: "Children in festive dress with medals on the Dasamahavidya Puja stage during the children's competitions",
        variant: "wide",
    },
    community: {
        label: "Community programme",
        src: "/assets/photos/CDP_COMMUNITY_PROGRAM.jpg",
        alt: "Bhog being served to members of the community at the Dasamahavidya Puja pandal in Chetla",
        variant: "doc",
        focus: "center 38%",
    },
    agnikar: {
        label: "Agnikar",
        src: "/assets/photos/CDP_ANGIKAR.jpg",
        alt: "Agnikar, Chetla — volunteers and community members at a year-round social-work event, with a wheelchair presented to a recipient",
        variant: "doc",
        focus: "center 30%",
    },
    sanctum: {
        label: "The sanctum at Chetla",
        src: "/assets/photos/CDP_SANCTRUM.jpg",
        alt: "The sanctum at Chetla — the yellow-walled shrine where the Puja takes place, with photographs of the ten Mahavidyas arranged in an arch above the railed platform and lamps burning below",
        variant: "portrait",
    },
    archive: { label: "Historical photograph — archive", src: null, variant: "doc" },
};

export const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "/mahavidyas", label: "The Ten Mahavidyas" },
    { to: "/culture-community", label: "Culture & Community" },
    { to: "/partnerships", label: "Partnerships" },
    { to: "/contact", label: "Contact Us" },
    { to: "/media-features", label: "Media Features" },
];

export const LEGAL_LINKS = [
    { to: "/privacy-policy", label: "Privacy Policy" },
    { to: "/cookie-policy", label: "Cookie Policy" },
    { to: "/terms-of-use", label: "Terms of Use" },
    { to: "/photography-notice", label: "Event Photography Notice" },
];

export const SEO = {
    home: {
        title: "Dasamahavidya Puja, Chetla, Kolkata | 112 Years of Shyama Puja",
        description:
            "Discover Dasamahavidya Puja in Chetla, Kolkata, organised by Chetla Sarbasadharaner Kali Puja Trust: 112 years of Shyama Puja, 48 years of Dasamahavidya Puja, culture and community service.",
    },
    mahavidyas: {
        title: "The Ten Mahavidyas | Dasamahavidya Puja, Chetla",
        description:
            "Learn about the ten sacred forms of the Divine Mother and the place of Adi Maa and Shyama Maa in Dasamahavidya Puja in Chetla, Kolkata.",
    },
    culture: {
        title: "Culture & Community | Dasamahavidya Puja, Chetla",
        description:
            "Discover the cultural programmes, children's competitions, Puja-season community initiatives and Agnikar's year-round social work in Chetla, Kolkata.",
    },
    partnerships: {
        title: "Partner With Dasamahavidya Puja | Chetla, Kolkata",
        description:
            "Explore partnership opportunities with Chetla Sarbasadharaner Kali Puja Trust, celebrating 112 years of Shyama Puja and 48 years of Dasamahavidya Puja in Chetla, Kolkata.",
    },
    contact: {
        title: "Contact Dasamahavidya Puja | Chetla Sarbasadharaner Kali Puja Trust",
        description:
            "Contact Chetla Sarbasadharaner Kali Puja Trust for information about Dasamahavidya Puja, cultural programmes, community initiatives and partnership enquiries.",
    },
    media: {
        title: "Media Features | Dasamahavidya Puja, Chetla",
        description:
            "Explore verified press coverage, interviews and published features relating to Dasamahavidya Puja and Chetla Sarbasadharaner Kali Puja Trust.",
    },
    privacy: {
        title: "Privacy Policy | Dasamahavidya Puja",
        description:
            "Understand how Dasamahavidya Puja and Chetla Sarbasadharaner Kali Puja Trust collect, use, and protect your personal information.",
    },
    cookies: {
        title: "Cookie Policy | Dasamahavidya Puja",
        description:
            "Learn about the cookies and tracking technologies used on the Dasamahavidya Puja website.",
    },
    terms: {
        title: "Terms of Use | Dasamahavidya Puja",
        description:
            "Read the terms and conditions for using the Dasamahavidya Puja website.",
    },
    photography: {
        title: "Event Photography Notice | Dasamahavidya Puja",
        description:
            "How photographs and video from Dasamahavidya Puja events may be used by Chetla Sarbasadharaner Kali Puja Trust.",
    },
};

export const HOME = {
    heroEyebrow: "Chetla Sarbasadharaner Kali Puja Trust",
    heroLine1: "112 Years of Shyama Maa",
    heroLine2: "48 Years of Dasamahavidya Puja",
    heroTagline: "A living tradition of devotion, culture and community.",
    welcome: [
        "For generations, families in Chetla have come together for this Puja. The worship, the gatherings, the music and the children's competitions have all become part of the neighbourhood's story.",
        "Welcome to Dasamahavidya Puja, organised by Chetla Sarbasadharaner Kali Puja Trust. Our celebration brings together the worship of Shyama Maa, the ten Mahavidyas and Adi Maa. The night-long Dasamahavidya observance includes Kumari Puja and homa/yajna, alongside cultural programmes, children's competitions and community initiatives.",
    ],
    legacy: {
        title: "Two traditions, one community",
        body: [
            "In 2026, we celebrate the 112th year of Shyama Puja and the 48th year of Dasamahavidya Puja. These are more than numbers. They reflect generations of prayer, shared memories and community participation that have made the celebration part of life in Chetla.",
        ],
    },
    sequence: {
        title: "The distinctive sequence of worship",
        intro: "Our Puja has a distinctive rhythm. This extended sequence follows the tradition preserved by our community.",
        steps: [
            {
                title: "Shyama Puja",
                body: "Shyama Maa is worshipped during Kali Puja and immersed a day or two later.",
            },
            {
                title: "The worship continues",
                body: "The Dasamahavidya idols remain with Adi Maa, and the worship continues one day before Chhath Puja.",
            },
            {
                title: "The night-long observance",
                body: "That night includes Dasamahavidya Puja, Kumari Puja and homa/yajna. The observance continues through the night and concludes with morning rites.",
            },
            {
                title: "Immersion on Chhath Puja",
                body: "The idols are immersed on Chhath Puja, bringing this extended celebration to its close.",
            },
        ],
    },
    vidyaIntro: {
        title: "The Ten Mahavidyas and Adi Maa",
        body: "At the heart of our celebration stand the ten Mahavidyas — ten great forms of wisdom of the Divine Mother — with Adi Maa placed at the centre of our Puja arrangement. The first Mahavidya is worshipped in our tradition as Maa Shabashivam Kali.",
    },
    highlights: {
        title: "A festival of devotion, art and belonging",
        body: [
            "Alongside the religious observances, our programme brings people together through music, dance and vocal performances. Established artists share the stage with local performers. Children take part in drawing, singing and dance competitions, finding room to learn, perform and be encouraged.",
            "Kumari Puja is performed during the night-long Dasamahavidya observance — one of the most quietly moving moments of the celebration.",
        ],
    },
    community: {
        title: "Care that continues beyond the pandal",
        body: [
            "During the Puja, our community activities include distributing blankets, providing educational stationery to children in need and arranging bhog.",
            "Our sister initiative, Agnikar, works throughout the year with orphanages, children from economically disadvantaged backgrounds and other underserved communities. Together, these efforts connect the festival with a wider, ongoing commitment to community care.",
        ],
    },
    partnershipInvite: {
        title: "Partner with a living tradition",
        body: "We are preparing partnership opportunities for businesses and organisations that would like to be associated with this long-standing celebration of worship, culture and community work.",
    },
};

export const MAHAVIDYA_INTRO = {
    title: "One Divine Mother, ten great forms of wisdom",
    body: [
        "The word Mahavidya is often understood as “great wisdom” or “great knowledge”. The Dasha Mahavidyas are ten forms of the Divine Mother honoured in Shakta traditions. Each has a distinct name, appearance and meaning. Some are shown as gentle and graceful; others appear fierce or unusual. Together, they offer different ways of understanding the power, wisdom and presence of the Divine Mother.",
        "In our celebration, the first Mahavidya is worshipped as Maa Shabashivam Kali. The other forms introduced here are Maa Tara, Maa Shodashi (Shoroshi), Maa Bhuvaneshwari, Maa Bhairavi, Maa Chhinnamasta, Maa Dhumavati, Maa Bagalamukhi (Bogola), Maa Matangi and Maa Kamala (Komola). Kumari Puja is also performed on the night of Dasamahavidya Puja. Names, images and interpretations may differ across traditions; the descriptions below offer a simple introduction for visitors of all ages.",
    ],
};

export const MAHAVIDYAS = [
    {
        num: "1",
        name: "Maa Shabashivam Kali",
        tagline: "Power, time and transformation",
        slot: "vidyaKali",
        body: "At our Puja, Maa Shabashivam Kali is honoured as the first of the ten Mahavidyas. Kali is a deeply revered form of the Divine Mother, especially in Bengal, and is often shown in a powerful, fierce form. In Shakta traditions, this imagery expresses the force of Shakti and the power of transformation. We use the full name Maa Shabashivam Kali for the form worshipped in our celebration.",
    },
    {
        num: "2",
        name: "Maa Tara",
        tagline: "The guide through difficulty",
        slot: "vidyaTara",
        body: "Maa Tara is often described as a guide who helps devotees cross difficulties and move towards spiritual freedom. In the Mahavidya tradition, she is connected with wisdom and protection. Some images of Maa Tara may resemble images of Maa Kali, but Tara has her own identity, stories and place in worship.",
    },
    {
        num: "3",
        name: "Maa Shodashi / Tripura Sundari — Maa Shoroshi",
        tagline: "Beauty of the three worlds",
        slot: "vidyaShoroshi",
        body: "Maa Shoroshi, also known as Shodashi or Tripura Sundari, is associated with beauty and grace across the three worlds. She holds an important place in Sri Vidya traditions. Her name and imagery point to divine beauty and fullness. Her appearance is shown in different ways across religious texts, artworks and traditions.",
    },
    {
        num: "4",
        name: "Maa Bhuvaneshwari",
        tagline: "The Lady of the Worlds",
        slot: "vidyaBhuvaneshwari",
        body: "Maa Bhuvaneshwari is associated with the worlds and the universe. She is often understood as a form of the Divine Mother whose presence embraces all creation. Traditional descriptions also connect her with knowledge and the elements that make up the physical world. Her name reminds us of the vastness of the universe and the Goddess's place within it.",
    },
    {
        num: "5",
        name: "Maa Bhairavi",
        tagline: "The fierce and formidable Goddess",
        slot: "vidyaBhairavi",
        body: "Maa Bhairavi is a fierce and powerful form of the Divine Mother. Her name is linked with Bhairava, a formidable form of Shiva. Her traditional imagery speaks to themes of change, endings and mortality. Though her appearance can be intense, she is approached with reverence in Shakta traditions.",
    },
    {
        num: "6",
        name: "Maa Chhinnamasta — Maa Chhinamasta",
        tagline: "A striking and powerful form",
        slot: "vidyaChhinamasta",
        body: "Maa Chhinnamasta is one of the most striking forms among the Mahavidyas. In traditional images, she holds her own severed head, with streams of blood shown flowing from her neck. This intense image has been interpreted in connection with life-force, self-offering and the close relationship between life and death. Its meaning is complex, and explanations differ across traditions.",
    },
    {
        num: "7",
        name: "Maa Dhumavati",
        tagline: "Wisdom in life's difficult moments",
        slot: "vidyaDhumavati",
        body: "Maa Dhumavati has a unique place among the ten Mahavidyas. In some traditional images, she appears as an elderly widow. Her form is associated with difficult parts of life—such as loss, loneliness and uncertainty—that people may prefer not to speak about. In the Mahavidya tradition, she is treated with reverence and reminds us that wisdom is not found only in happiness, beauty or prosperity; it can also come from facing life's hardships. Different traditions interpret her symbolism in different ways.",
    },
    {
        num: "8",
        name: "Maa Bagalamukhi — Maa Bogola",
        tagline: "The power to still or restrain",
        slot: "vidyaBogola",
        body: "Maa Bagalamukhi, known in Bengali as Maa Bogola, is associated with the power to still or restrain harmful actions and speech. In traditional images, she is shown holding an opponent's tongue, symbolising the power to stop damaging words or disruptive forces.",
    },
    {
        num: "9",
        name: "Maa Matangi",
        tagline: "Wisdom, speech, music and the arts",
        slot: "vidyaMatangi",
        body: "Maa Matangi is associated with speech, music, learning, knowledge and the arts. She is sometimes compared with Saraswati, though she has her own identity in Mahavidya traditions. Her stories and imagery also explore social boundaries and ideas of purity. She reminds us that wisdom and creativity can be understood in more ways than conventional learning alone.",
    },
    {
        num: "10",
        name: "Maa Kamala — Maa Komola",
        tagline: "The lotus and abundance",
        slot: "vidyaKomola",
        body: "Maa Kamala, known in Bengali as Maa Komola, is associated with the lotus, prosperity, well-being and abundance. She shares some visual features with Maa Lakshmi, including the lotus as a symbol of beauty and auspiciousness. Within the group of ten Mahavidyas, Maa Kamala has her own distinct place and meaning.",
    },
];

export const ADI_MAA = {
    title: "Adi Maa at the centre of our Puja",
    body: "At the centre of our Puja, Adi Maa is placed and worshipped alongside the ten Mahavidyas. This is an important part of how Dasamahavidya Puja is observed in Chetla. The arrangement describes our local celebration; other traditions may arrange or understand the forms differently.",
};

export const SHYAMA_MAA = {
    title: "Shyama Maa: part of the wider celebration",
    body: "Shyama Maa has a special place in the wider celebration and in the history of our community. In 2026, we celebrate the 112th year of Shyama Puja. After her immersion, the worship of the ten Mahavidyas continues, with their idols remaining alongside Adi Maa. Kumari Puja is performed during the night-long Dasamahavidya observance, which also includes homa/yajna and concludes with morning rites. The final immersion takes place on Chhath Puja, connecting these two parts of our local festival.",
};

export const CULTURE = {
    intro: {
        title: "The celebration reaches beyond the rituals",
        body: "The Puja is at the heart of our celebration, but the pandal is also a place where people meet, enjoy performances and cheer on young talent. Alongside the religious observances, Kumari Puja is performed during the night-long Dasamahavidya Puja. Music, dance, children's competitions and community activities bring different generations together in Chetla.",
    },
    artists: {
        title: "A stage for artists and local talent",
        body: "Our cultural programmes feature singers, dancers, vocal artists and other performers, including established names and talents from the local community. We believe a community celebration should offer people a chance both to enjoy art and to share it. By making room for emerging performers alongside experienced artists, the programme helps local talent meet a live audience and become part of the festival's story.",
    },
    children: {
        title: "A place for children to create and perform",
        body: "Drawing, singing and dance competitions give children a chance to try something new, show what they can do and enjoy being part of a shared celebration. These events are not only competitions; they are moments for confidence, encouragement and the simple happiness of taking the stage or showing a piece of work to others.",
    },
    kumari: {
        title: "Kumari Puja",
        body: "Kumari Puja is performed during the night-long Dasamahavidya observance. It is one of the most quietly moving moments of our celebration, held with reverence as part of the night of worship.",
    },
    care: {
        title: "Care that continues beyond the pandal",
        body: "During the Puja, our community initiatives include distributing blankets to people in need, providing educational stationery to children from economically disadvantaged backgrounds and arranging bhog for members of the community. These activities are organised alongside the celebration and form a practical part of our connection with the wider community.",
    },
    agnikar: {
        title: "Year-round social work through Agnikar",
        body: "Our sister initiative, Agnikar, carries out social work throughout the year with orphanages, children from economically disadvantaged backgrounds and other underserved communities. Its work extends beyond the Puja season and reflects an ongoing commitment to people and communities who may need support.",
    },
};

export const PARTNERSHIPS = {
    title: "Partnership opportunities",
    status: "Our partnership formats are being prepared",
    intro: "We are putting together partnership opportunities for brands and organisations that want to be part of a well-established local celebration shaped by worship, cultural performances, children's activities and community work. We will share the available formats and deliverables once the committee has finalised them.",
    rooted: {
        title: "Partner with a tradition rooted in Chetla",
        body: [
            "In 2026, Chetla Sarbasadharaner Kali Puja Trust celebrates the 112th year of Shyama Puja and the 48th year of Dasamahavidya Puja. The celebration brings together worship, cultural performances, children's competitions and community initiatives. We are preparing partnership opportunities for businesses and organisations that would like to be associated with this long-standing tradition.",
            "Our partnership formats are being finalised. Businesses and organisations interested in a brand, cultural-programme or community partnership can contact us for a preliminary conversation. We will share confirmed formats, deliverables and terms once the committee has approved them.",
        ],
    },
    note: "Partnership proposals will include confirmed formats, deliverables, recognition options and terms once these have been approved by the committee.",
};

export const CONTACT_PAGE = {
    title: "We would be glad to hear from you",
    subtitle: "Contact the organising committee",
    intro: "Whether you are a devotee, a neighbour, a local artist, a parent, a media representative, a potential partner or someone who wants to learn more about our tradition, please get in touch. We will do our best to direct your enquiry to the right person on the committee.",
    reasons: [
        "General enquiry",
        "Puja information",
        "Cultural participation",
        "Community initiative",
        "Partnership enquiry",
        "Media enquiry",
        "Other",
    ],
    consentLabel:
        "I have read the Privacy Policy and understand how the Trust will use the information I submit to respond to this enquiry.",
    previewNotice:
        "This form is currently a preview and is not yet connected to an email service. Your message will not be sent from here. Until the connection is in place, please email us directly and we will respond as soon as practicable. Please do not send passwords, banking credentials, identity documents or other sensitive personal information.",
};

export const MEDIA = {
    title: "Stories and coverage",
    body: [
        "This page will bring together verified media coverage, interviews and published features about Dasamahavidya Puja, the traditions maintained by Chetla Sarbasadharaner Kali Puja Trust, and the cultural and community activities organised alongside the celebration.",
        "We are compiling the archive. Confirmed articles, broadcasts and interviews will be added here with their publication details and links, so visitors can read or view the original coverage.",
    ],
    journalists: {
        title: "For journalists and media organisations",
        body: "For information about the Puja, requests for an interview, historical context or permission to use photographs, please contact the organising committee. Please include your publication or organisation, deadline and the nature of your enquiry.",
    },
    archiveNote:
        "Every item published here will include the publication or outlet, the headline or programme title, the date and a working link to the original coverage.",
};
